'use strict';
angular.module('trsUploadFullServiceModule', ['fullImageUploadModule']).factory('trsUploadFullService', ['$modal', 'editingCenterService',
    function($modal, editingCenterService) {
        return {

            /**
             * [fullImageUpload description] 列表图，导图，题图，焦点图上传弹窗
             * @param  {Boolean} isShowPeraonalMaterial [description] 是否展示添加到个人素材的选项
             * @param  {[type]}  maxSize                [description] 最大尺寸
             * @param  {Boolean} isFinish               [description] 是否没有后续操作
             * @param  {[type]}  success                [description] 成功后的回调函数
             * @return {[type]}                         [description]
             */
            fullImageUpload: function(isShowPeraonalMaterial, maxSize, isFinish, success) {
                // var modalInstance = $modal.open({
                //     templateUrl: './components/util/trsImageUpload/fullImageUpload/fullImageUpload_tpl.html',
                //     windowClass: 'fullImageUpload',
                //     backdrop: false,
                //     resolve: {
                //         options: function() {
                //             return {
                //                 maxSize: maxSize,
                //                 isShowPeraonalMaterial: isShowPeraonalMaterial,
                //                 isFinish: isFinish
                //             };
                //         }
                //     },
                //     controller: 'fullImageUploadCtrl'
                // });
                // modalInstance.result.then(function(result) {
                //     success(result);
                // });

                // 图片对接媒资库
                let options = {
                    resourceType: '0',
                    isMulti: false
                };
                editingCenterService.mediaSelector(options).then(function(result) {
                    var data = {
                        file: {
                            size: result.list[0].resourcesize,
                            ext: result.list[0].resourcetitle,
                        },
                        src: {
                            imgName: result.list[0].resourceurl.substring(result.list[0].resourceurl.lastIndexOf('\/') + 1).split('?')[0],
                            imgSrc: result.list[0].resourceurl,
                        },
                        resource: {
                            meiziId: result.list[0].resourceid,
                            relationId: result.list[0].relationid
                        }
                    };
                    success({data: data, isAddPersonalMaterial: result.isAddPersonalMaterial});
                });
            },
        };
    }
]);
